module.exports = __webpack_public_path__ + "static/img/office_6.4974836.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/recruit_2021/welfare/office_6.png
// module id = MiQo
// module chunks = 0